(function () {
  "use strict";

  let map;
  let geocoder;
  let marker;

  // Retorna o endereço completo formatado
  function getAddress() {
    // Verifica se as informações foram preenchidas
    if (
      $("#logradouro").val() != "" &&
      $("#bairro").val() != "" &&
      $("#cidade").val() != "" &&
      $("#estado").val() != ""
    ) {
      const logradouro = $("#logradouro").val();
      const numero = $("#numero").val();
      const bairro = $("#bairro").val();
      const cidade = $("#cidade").val();
      const estado = $("#estado").val();
      const pais = $("#pais").val();
      let endereco =
        logradouro +
        ", " +
        numero +
        ", " +
        bairro +
        ", " +
        cidade +
        ", " +
        estado +
        ", " +
        pais;
      endereco = clearAddress(endereco);
      return endereco;
    }
    return false;
  }

  // Limpa o endereço
  function clearAddress(string) {
    return string.replace(/\s/g, "+");
  }

  // Obtém a posição no mapa do endereço passado
  function getGeocodeFromAddress(address) {
    geocoder.geocode({ address: address }, function (results, status) {
      if (status === "OK") {
        const position = results[0].geometry.location;
        setCoordinates(formatPosition(position));
        setMapLocale(position);
      } else {
        showAlert(
          "Atenção",
          "Não foi possível encontrar o endereço informado.",
          "warning"
        );
      }
    });
  }

  // Cria um marcador no local informado no mapa
  function setMapLocale(position) {
    map.setCenter(position);
    if (marker !== undefined) {
      marker.setMap(null);
    }
    marker = new google.maps.Marker({
      map: map,
      draggable: true,
      animation: google.maps.Animation.DROP,
      position: position,
      icon: url_base + "app/assets/dist/img/maps/marker.png",
    });
    marker.addListener("dragend", handleMarker);
    map.setZoom(16);
  }

  // Formata as coordenadas para String
  function formatPosition(position) {
    return {
      lat: position.lat().toFixed(6),
      lng: position.lng().toFixed(6),
    };
  }

  // Obtém as novas coordenadas ao mover o marcador
  function handleMarker() {
    const position = marker.getPosition();
    setCoordinates(formatPosition(position));
  }

  // Passa as coordenadas para o campo
  function setCoordinates(coordinates) {
    $("#lat").val(coordinates.lat);
    $("#lng").val(coordinates.lng);
  }

  // Obtem as coordenadas do campo
  function getCoordinates() {
    const coordinates = $("#lat").val() + ", " + $("#lng").val();
    return {
      lat: Number($("#lat").val()),
      lng: Number($("#lng").val()),
    };
  }

  // Evento de click no botão para encontrar o local no mapa
  $(".btn-mapa").on("click", function (e) {
    e.preventDefault();
    if (getAddress()) {
      const address = getAddress();
      getGeocodeFromAddress(address);
    } else {
      showAlert(
        "Atenção",
        "Não foi possível encontrar o local no mapa. Por favor, informe o endereço corretamente.",
        "warning"
      );
    }
  });

  // Inicializa o mapa (Formulário)
  function initMapForm() {
    map = new google.maps.Map(document.getElementById("form-mapa-anuncio"), {
      zoom: 3,
      center: { lat: -15.90812, lng: -47.983592 }, // <- Brasília
      streetViewControl: false,
    });
    geocoder = new google.maps.Geocoder();
    // Carrega a posição no mapa ao editar
    if ($("#lat").val() != "" && $("#lng").val() != "") {
      const position = getCoordinates();
      setMapLocale(position);
    }
  }

  // MAPA
  $(window).load(function () {
    if ($("#form-mapa-anuncio").length > 0) {
      initMapForm();
    }
  });

  let enviando_formulario = false;

  // CADASTRAR / EDITAR
  $("#form-anuncio").on("submit", function (e) {
    e.preventDefault();

    var obj = this;
    var form = $(obj);
    var submit_btn = form.find("#cadastrar");
    var submit_btn_text = submit_btn.text();
    var dados = new FormData(obj);

    function volta_submit() {
      submit_btn.attr("disabled", false);
      submit_btn.text(submit_btn_text);
      enviando_formulario = false;
      hideLoading();
    }

    if (!enviando_formulario) {
      $.ajax({
        url: form.attr("action"),
        type: form.attr("method"),
        data: dados,
        processData: false,
        cache: false,
        contentType: false,
        beforeSend: function () {
          showLoading();
          enviando_formulario = true;
          submit_btn.attr("disabled", true);
          submit_btn.text("Aguarde...");
        },
        success: function (response) {
          console.log(response);
          response = JSON.parse(response);
          if (response.status == "ok") {
            window.location.href = response.url;
          } else {
            volta_submit();
            showAlert(
              "Erro",
              "Não foi possível realizar essa operação.",
              "error"
            );
          }
        },
        error: function (xhr, type, exception) {
          volta_submit();
          showAlert(
            "Erro",
            "Não foi possível realizar essa operação.",
            "error"
          );
          console.log("ajax error response type " + type);
        },
      });
    }
  });

  // REMOVE ANÚNCIO
  $("#form-remove-anuncio").on("submit", function (e) {
    e.preventDefault();
    var obj = this;
    var form = $(obj);
    var dados = new FormData(obj);
    var idRemove = $("#id_remove").val();
    function volta_submit() {
      enviando_formulario = false;
      hideLoading();
    }
    if (!enviando_formulario) {
      $.ajax({
        url: form.attr("action"),
        type: form.attr("method"),
        data: dados,
        processData: false,
        cache: false,
        contentType: false,
        beforeSend: function () {
          closeModal("modal-confirm");
          showLoading();
          enviando_formulario = true;
        },
        success: function (data) {
          //console.log(data);
          volta_submit();
          data = JSON.parse(data);
          if (data.status == "ok") {
            $("#id_remove").val("");
            showAlert("Sucesso", "Anúncio removido com sucesso.", "success");
            setTimeout(() => {
              location.reload();
            }, 2000);
          } else {
            volta_submit();
            showAlert(
              "Erro",
              "Não foi possível realizar essa operação.",
              "error"
            );
          }
        },
        error: function (xhr, type, exception) {
          volta_submit();
          showAlert(
            "Erro",
            "Não foi possível realizar essa operação.",
            "error"
          );
          console.log("ajax error response type " + type);
        },
      });
    }
  });
})();
